import React from 'react';
import { Fab } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

/**
 * Reusable Floating Action Button for add operations
 * @param {Object} props
 * @param {Function} props.onClick - Function to call when the FAB is clicked
 * @param {Object} props.sx - Additional styles to apply to the FAB
 */
const AddFab = ({ onClick, sx = {} }) => {
  return (
    <Fab
      color="primary"
      aria-label="add"
      onClick={onClick}
      sx={{
        position: 'fixed',
        bottom: 16,
        right: 16,
        ...sx
      }}
    >
      <AddIcon />
    </Fab>
  );
};

export default AddFab;